@for (colorGroup of colorSchema; track colorGroup) {
  <div class="row">
    @for (color of colorGroup; track color) {
      <button [class.selected]="isColorSelected(color)" class="color" [style.background-color]="color" (click)="onClick(color)">
        &nbsp;
      </button>
    }
  </div>
}
